<template>
  <div class="pb-32">
    <div class="bg-primary px-8 pt-8 mb-36 rounded-b-3xl h-72">
      <div class="mt-4">
        <UserDetailsComp is-transparent="true" />
      </div>
      <div class="mt-4 rounded-2xl overflow-hidden">
        <AttendanceButtonComp />
      </div>
    </div>

    <OfflineDatabaseComponent />
    <BannerComp />

    <!-- <EmergencyComp /> -->
    <!-- <van-search class="mb-2" v-model="filterFeature" round placeholder="Search for..." shape="round" /> -->

    <img :src="appLogo" alt="" class="absolute w-full opacity-25" />
    <FeatureItemsComp :search-filter="filterFeature" />

    <!-- <div class="absolute bottom-0 text-sm text-center w-full">
      Whatever you have to say, It greatly impact us. Think before act
    </div> -->
  </div>
</template>

<style scoped>
  .hero-bg {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='18' viewBox='0 0 100 18'%3E%3Cpath fill='currentColor' fill-opacity='0.10' d='M61.82 18c3.47-1.45 6.86-3.78 11.3-7.34C78 6.76 80.34 5.1 83.87 3.42 88.56 1.16 93.75 0 100 0v6.16C98.76 6.05 97.43 6 96 6c-9.59 0-14.23 2.23-23.13 9.34-1.28 1.03-2.39 1.9-3.4 2.66h-7.65zm-23.64 0H22.52c-1-.76-2.1-1.63-3.4-2.66C11.57 9.3 7.08 6.78 0 6.16V0c6.25 0 11.44 1.16 16.14 3.42 3.53 1.7 5.87 3.35 10.73 7.24 4.45 3.56 7.84 5.9 11.31 7.34zM61.82 0h7.66a39.57 39.57 0 0 1-7.34 4.58C57.44 6.84 52.25 8 46 8S34.56 6.84 29.86 4.58A39.57 39.57 0 0 1 22.52 0h15.66C41.65 1.44 45.21 2 50 2c4.8 0 8.35-.56 11.82-2z'%3E%3C/path%3E%3C/svg%3E");
    color: var(--ky-primary);
  }
</style>

<script>
  import FeatureItemsComp from "@/components/FeatureItemsComp.vue";
  import UserDetailsComp from "@/components/UserDetailsComp.vue";
  import OfflineDatabaseComponent from "@/components/OfflineDatabaseComponent.vue";
  import AttendanceButtonComp from "@/components/AttendanceButtonComp.vue";
  import BannerComp from "@/components/BannerComp.vue";
  // import EmergencyComp from "@/components/EmergencyComp.vue";
  // import FromDeveloper from "@/components/FromDeveloper.vue";
  // import { Carousel, Slide } from "vue-carousel";

  export default {
    name: "DashboardPage",
    data() {
      return {
        appLogo: process.env.VUE_APP_LOGO || "/images/time_transparent.png",
        filterFeature: ""
      };
    },
    components: {
      FeatureItemsComp,
      UserDetailsComp,
      OfflineDatabaseComponent,
      AttendanceButtonComp,
      BannerComp
      // EmergencyComp
      // FromDeveloper
      // Carousel,
      // Slide
    }
  };
</script>
